/**
 * What the positions of an invoice are called in the mask.
 *
 * The field names and the column headings have drifted apart: the column
 * "Gegenkonto" edits `taxRate`, and the percentage beside it is `tax`. Without
 * this table the refused save named the field ("taxRate") instead of the
 * column the user is looking at (#2206, R-135).
 */
export const INVOICE_POSITION_LABELS: Record<string, string> = {
    allItems: 'app.invoices.detail.atLeastOnePosition',
    quantity: 'app.table.column.quantity',
    price: 'app.table.column.price',
    discount: 'app.table.column.discount',
    taxRate: 'app.common.counterAccount',
    tax: 'app.table.column.tax',
    title: 'app.label.title',
    netShippingCosts: 'app.label.deliverCosts',
    netSurcharge: 'app.label.surcharges',
};

/**
 * The head of an invoice, where a field is not labelled under
 * `app.label.<field>`: the recipient field is headed "Rechnungsempfänger".
 */
export const INVOICE_OVERVIEW_LABELS: Record<string, string> = {
    recipientAccount: 'app.label.recipient',
};
